'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCountup = require('react-countup');

var _reactCountup2 = _interopRequireDefault(_reactCountup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DangerDial = function (_Component) {
  _inherits(DangerDial, _Component);

  function DangerDial() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DangerDial);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DangerDial.__proto__ || Object.getPrototypeOf(DangerDial)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      angle: 0,
      animationFrame: null
    }, _this.componentWillMount = function () {
      _this.updateDial();
    }, _this.componentWillReceiveProps = function () {
      _this.updateDial();
    }, _this.componentWillUnmount = function () {
      cancelAnimationFrame(_this.state.animationFrame);
    }, _this.updateDial = function () {
      // make sure that any previous calls have been killed
      if (_this.state.animationFrame) {
        cancelAnimationFrame(_this.state.animationFrame);
      }

      // Update the attribute for the angle after the component has mounted
      // so we can trigger the CSS animation
      var animationFrame = requestAnimationFrame(function () {
        _this.setState({
          angle: 180 * _this.props.percent / 100
        });
      }, 1);

      _this.setState({
        animationFrame: animationFrame
      });
    }, _this.getHeadingClass = function () {
      if (_this.props.percent >= 0 && _this.props.percent < 20) {
        return 'luna-dangerdial__heading--slice1';
      } else if (_this.props.percent >= 20 && _this.props.percent < 40) {
        return 'luna-dangerdial__heading--slice2';
      } else if (_this.props.percent >= 40 && _this.props.percent < 60) {
        return 'luna-dangerdial__heading--slice3';
      } else if (_this.props.percent >= 60 && _this.props.percent < 80) {
        return 'luna-dangerdial__heading--slice4';
      } else if (_this.props.percent >= 80 && _this.props.percent <= 100) {
        return 'luna-dangerdial__heading--slice5';
      } else {
        return null;
      }
    }, _this.renderHeading = function () {
      if (_this.props.name || typeof _this.props.start === 'number') {
        return _react2.default.createElement(
          'div',
          { className: _this.getHeadingClass() },
          _react2.default.createElement(
            'div',
            { className: 'luna-dangerdial__countup' },
            _react2.default.createElement(_reactCountup2.default, {
              end: _this.props.end,
              duration: _this.props.duration,
              start: _this.props.start,
              separator: ',',
              useGrouping: false
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'luna-dangerdial__title' },
            _this.props.name
          )
        );
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DangerDial, [{
    key: 'render',
    value: function render() {
      var rotate = 'rotate(' + this.state.angle + ' 108.93 111.42)';
      var style = {
        transform: 'rotate(' + this.state.angle + 'deg)',
        transformOrigin: '108.93px 111.42px'
      };

      return _react2.default.createElement(
        'div',
        null,
        this.renderHeading(),
        _react2.default.createElement(
          'svg',
          {
            className: 'luna-dangerdial',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 217.36 118.8'
          },
          _react2.default.createElement('path', {
            className: 'luna-dangerdial__slice1',
            d: 'M17.76,49.14A108.16,108.16,0,0,0,0,108.68v2.73H95.51a13.19,13.19,0,0,1,1.73-4.9Z',
            transform: 'translate(0 0.01)'
          }),
          _react2.default.createElement('path', {
            className: 'luna-dangerdial__slice2',
            d: 'M103.55,101L71.36,6.57a109,109,0,0,0-50.9,38.64l78.63,58.87A13.3,13.3,0,0,1,103.55,101Z',
            transform: 'translate(0 0.01)'
          }),
          _react2.default.createElement('path', {
            className: 'luna-dangerdial__slice3',
            d: 'M111.15,100.26l31-95a109.15,109.15,0,0,0-66.37-.2l30.84,95.12A12.58,12.58,0,0,1,111.15,100.26Z',
            transform: 'translate(0 0.01)'
          }),
          _react2.default.createElement('path', {
            className: 'luna-dangerdial__slice4',
            d: 'M118.22,104.09l78.67-58.9A109,109,0,0,0,146.36,6.7l-32.23,94.5A13.31,13.31,0,0,1,118.22,104.09Z',
            transform: 'translate(0 0.01)'
          }),
          _react2.default.createElement('path', {
            className: 'luna-dangerdial__slice5',
            d: 'M217.36,108.68a108.16,108.16,0,0,0-17.6-59.28l-79.53,57.42a13.19,13.19,0,0,1,1.63,5h95.5v-3.14Z',
            transform: 'translate(0 0.01)'
          }),
          _react2.default.createElement(
            'g',
            {
              className: 'luna-dangerdial__tuner',
              style: style,
              transform: rotate },
            _react2.default.createElement('path', {
              className: 'luna-dangerdial__tuner--needle',
              d: 'M109.82,104.28l-1.6-.13h0c-18-1.25-55.68,7.26-55.68,7.26s37.66,8.51,55.69,7.26h0.16a7.3,7.3,0,0,0,1.45-.15c5.22-.4,7.16-7.12,7.16-7.12S115,104.67,109.82,104.28Z',
              transform: 'translate(0 0.01)'
            }),
            _react2.default.createElement('circle', {
              className: 'luna-dangerdial__tuner--knob',
              cx: '108.93',
              cy: '111.42',
              r: '4.1'
            })
          )
        )
      );
    }
  }]);

  return DangerDial;
}(_react.Component);

DangerDial.propTypes = {
  percent: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string
};
exports.default = DangerDial;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/DangerDial/DangerDial.js